import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const ComplianceAndRegulationsTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader
        tabName={t('pageIntegrations.tabNames.compliance-and-regulations')}
      />
      <IntegrationsTable
        category={IntegrationCategory.COMPLIANCE_AND_REGULATIONS}
      />
    </section>
  );
};

export default ComplianceAndRegulationsTab;
